import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option?) {
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        realEstateAddress: this.formBuilder.group({
          street: [
            entity?.parameters?.realEstateAddress?.addressStreet || null,
            Validators.nullValidator,
          ],
          street2: [
            entity?.parameters?.realEstateAddress?.addressStreet2 || null,
            Validators.nullValidator,
          ],
          zipCode: [
            entity?.parameters?.realEstateAddress?.addressZipCode || null,
            Validators.nullValidator,
          ],
          city: [
            entity?.parameters?.realEstateAddress?.addressCity || null,
            Validators.nullValidator,
          ],
          country: [
            entity?.parameters?.realEstateAddress?.addressCountry
              ? {
                  value: entity?.parameters?.realEstateAddress?.addressCountry,
                  valueGb:
                    entity?.parameters?.realEstateAddress?.addressCountry,
                }
              : null,
          ],
        }),
        realEstateSurface: [entity?.parameters?.realEstateSurface || null],
        realEstatePropertyType: [
          entity?.parameters?.realEstatePropertyType || null,
        ],
        // purchaseDate: [entity?.parameters?.purchaseDate || null, isCristalisOrganization && sessionConsultant ? Validators.nullValidator : Validators.required],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as FormArray;
  }
  extract() {
    const formValue = _.cloneDeep(this.form.value);
    const products = formValue.products.map(product => {
      const realEstateAddress = this.transformAddress(
        product?.parameters.realEstateAddress,
      );

      return {
        ...product,
        parameters: {
          ..._.omit(product.parameters, ['realEstateAddress']),
          realEstateAddress: { ...realEstateAddress },
        },
      };
    });
    const obj = {
      ...formValue,
      products,
    };

    return obj.products;
  }
  transformAddress(originalAddress: {
    street: string;
    street2?: string;
    zipCode: string;
    city: string;
    country: any;
  }) {
    const address = originalAddress
      ? (({ street, street2, zipCode, city, country }) => ({
          addressStreet: street,
          addressStreet2: street2,
          addressZipCode: zipCode,
          addressCity: city,
          addressCountry: country?.value ? country.value : country || '',
        }))(originalAddress)
      : {};
    return address;
  }
}
